// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as R from 'ramda'
import { forkJoin, of } from 'rxjs'
import { filter, mergeMap, switchMap, tap } from 'rxjs/operators'
import { Profiler } from '@weblite/profiler'
import { DATA_USER_CONNECT } from '@weblite/action/gateway'
import { DATA_AUTH_SIGNOUT } from '@weblite/action/auth'
import { sendBecomeOnline } from '@weblite/ts-action/gateway'
import { serverSub } from '$func/subscription'
import { fromObservable } from '$func/effectUtils'
import {
  dispatchSetConnectionStatus,
  SET_CONNECTION_STATUS,
} from '$comp/main/root.action'
import { sendSocketConnectedEventToWapps } from '$logic/wapp-subscribed-topics'
import { retryUntilSucceedWithCancel$ } from '$func/retryFunction'
import { changeConnectionStatus, sendNow } from '$setup/ws'
import { Feature, features } from '$setup/features'
import { delayedSyncFuncs, immediateSyncFuncs } from './sync-functions'
import afterSignOut from '../../hooks/after/signout'
import { connectWebSocketProfiler } from '$hooks/after/connection'
import {
  ProfilerAction,
  sendStartupProfilerEvent,
  StartupProfilerEventType,
} from '$logic/profiler'
import { createCallbackManager } from '$func/callbacks'
import { authStorage } from '$logic/auth/storage'
import { saveSignOutByServerAnalyticsEventToRam } from '$logic/auth/sign-out-analytics'

export const updateAppProfiler = new Profiler(ProfilerAction.UPDATE_APP)

export const connectionCallbackManager = createCallbackManager()

serverSub.subscribeToAll(
  fromObservable(action$ =>
    action$.pipe(
      filter(R.propEq('type', DATA_USER_CONNECT)),
      tap(() => {
        connectWebSocketProfiler.stop()
        updateAppProfiler.start()

        dispatchSetConnectionStatus('updating')
        sendStartupProfilerEvent(StartupProfilerEventType.CONNECT_APP)

        sendSocketConnectedEventToWapps()
        // connectionReport.setUpdating()
      }),
      switchMap(() =>
        of(immediateSyncFuncs).pipe(
          mergeMap(syncFuncs =>
            forkJoin(
              syncFuncs.map(syncFunc =>
                retryUntilSucceedWithCancel$(
                  syncFunc,
                  action$.pipe(filter(R.propEq('type', SET_CONNECTION_STATUS))),
                ),
              ),
            ),
          ),
        ),
      ),
      tap(() => {
        dispatchSetConnectionStatus('connected')
        connectionCallbackManager.runCallbacks()

        updateAppProfiler.stop()
        sendStartupProfilerEvent(StartupProfilerEventType.SYNC_APP, true)

        if (features.has(Feature.DELAYED_ONLINE_STATUS)) {
          sendNow(sendBecomeOnline)
        }

        delayedSyncFuncs.forEach(func => func())
        changeConnectionStatus()
      }),
    ),
  ),
)

serverSub.subscribe(DATA_AUTH_SIGNOUT, () => {
  const auth = authStorage.get()
  saveSignOutByServerAnalyticsEventToRam(auth?.userId)
  afterSignOut()
})
